import {createSlice} from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const bookingHoldAdapter = getAdapter({idFieldName: 'value'} );

const bookingHoldSlice = createSlice({
    name: 'bookingHold',
    initialState: bookingHoldAdapter.getInitialState(),
    reducers: {
        setBookingHold: (state, {payload: {bookingHold}}) => {
            bookingHoldAdapter.setAll(state, bookingHold);
        }
    }
});

const selectors = bookingHoldAdapter.getSelectors(({bookingHold}) => bookingHold);

export const getBookingHold = state =>  selectors.selectAll(state);

export const {setBookingHold} = bookingHoldSlice.actions;
export default bookingHoldSlice.reducer;